import React, { Component } from 'react';
import { Header, Input, Button, Responsive } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

class App extends Component {
  state = {
    id: null
  };
  render() {
    return (
      <div style={{ margin: 'auto' }}>
        <Header
          as="h1"
          style={{
            color: 'black'
          }}
        >
          Vérifiez un document ParapheOnline en entrant le code de vérification
          :
        </Header>
        <hr />
        <Responsive maxWidth={768}>
          <div>
            <Input
              style={{ minWidth: '100%', marginTop: '20px' }}
              placeholder="Entrez un code de vérification"
              onChange={(e, data) => {
                e.preventDefault();
                this.setState({ id: data.value });
              }}
            />
          </div>

          <Button
            disabled={this.state.id === null}
            as={Link}
            to={'/controle/' + this.state.id}
            type="submit"
          >
            Vérifier
          </Button>
        </Responsive>
        <Responsive minWidth={769}>
          <Input
            style={{ minWidth: '400px', marginTop: '20px' }}
            placeholder="Entrez un code de vérification"
            onChange={(e, data) => {
              e.preventDefault();
              this.setState({ id: data.value });
            }}
          >
            <input />
            <Button
              disabled={this.state.id === null}
              as={Link}
              to={'/controle/' + this.state.id}
              type="submit"
            >
              Vérifier
            </Button>
          </Input>
        </Responsive>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Control/ControlHome.js